module.exports = __webpack_public_path__ + "media/app/containers/CheckoutPage/EmptyCart.ad01f875.svg";